<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <!-- <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon> -->
            {{ $t('phone_verification') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-img src="@/assets/images/svg/phone_verification.svg" />
        <div class="mt-8 text-center">
          <div class="title font-weight-bold">
            {{ $t('verify_your_phone_number') }}
          </div>
          <div class="mt-4" v-html="$t('we_will_call_please_check', { phone: data_verification.value.phone })" />
        </div>
        <div v-if="isCall || (formattedTimeLeft !== 'EXPIRED' && formattedTimeLeft !== '00:00')" class="mt-4">
          <div :class="[`d-flex justify-center align-center`, { 'phone-error': hasError }]">
            <div class="sec-phone">
              <div class="">
                +62 999 - 9999 -
              </div>
            </div>
            <div class="ml-3">
              <CodeInput :loading="false" :fields="4" :auto-focus="true" :field-width="50" :field-height="50" class="input inputVerificationCode" @change="onChangeOtp" @complete="onCompleteOtp" />
              <div v-if="hasError" class="phone-has-error">
                {{ $t('number_is_invalid') }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full menu-full-flat">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div :class="[`mb-3`, { 'd-flex justify-space-between': formattedTimeLeft === 'EXPIRED' }]">
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOpt(2)">
              {{ $t('recall') }}
            </div>
            <div v-if="formattedTimeLeft !== 'EXPIRED' && formattedTimeLeft !== '00:00'" class="text-center" v-html="$t('recall_available_in', { time: formattedTimeLeft })" />
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOpt(1)">
              {{ $t('use_sms_instead') }}
            </div>
          </div>
          <v-btn v-if="formattedTimeLeft === 'EXPIRED' || formattedTimeLeft === '00:00'" :disabled="formattedTimeLeft === 'EXPIRED'" type="submit" color="primary" block x-large class="text-none" @click="callNow()">
            {{ $t('call_now') }}
          </v-btn>
          <v-btn v-else type="submit" :disabled="disabled_verify" color="primary" block x-large class="text-none" @click="verifyNow()">
            {{ $t('verify') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import {
  registerV2 as registerV2Customer,
  verification as verificationCustomer,
  sendOtp as sendOtpCustomer
} from '@/api/auth'
export default {
  data() {
    return {
      isCall: false,
      hasError: false,
      form: {
        key_pre_register: '',
        otp_type: 2
      },
      data_verification: {},
      disabled_verify: true,
      form_data: {
        phone: '',
        email: '',
        otp_code: ''
      },
      timerInterval: null,
      distance: 0
    }
  },
  computed: {
    formattedTimeLeft() {
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = minutes + ':' + seconds
      }
      return result
    }
  },
  watch: {
    formattedTimeLeft: function(newItem, oldItem) {
      if (newItem === 'EXPIRED' || newItem === null) {
        this.disabled_verify = true
      }
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
    if (this.data_verification.data) {
      this.getExpiryTime(this.data_verification.data.detail.expiry_date)
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async callNow() {
      try {
        this.form.key_pre_register = this.data_verification.key_pre_register
        const { data } = await registerV2Customer(this.form)
        this.$store.state.loading_axios = false
        this.data_verification.value.id = data.data.id
        this.data_verification.data = data.data
        this.$store.dispatch('save_type_verification', 'phone')
        this.$store.dispatch('data_verification', this.data_verification)
        this.isCall = true
        this.getExpiryTime(data.data.detail.expiry_date)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async verifyNow() {
      try {
        this.form_data.phone = this.data_verification.value.phone
        const { data } = await verificationCustomer(this.form_data)
        this.$store.state.loading_axios = false
        this.$store.dispatch('save_token', data)
        this.$store.dispatch('remove_data_verification')
        this.$store.dispatch('remove_type_Verification')
        this.$router.push({ name: 'register_success', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      } catch (e) {
        this.hasError = true
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    onChangeOtp(v) {
      this.hasError = false
    },
    onCompleteOtp(v) {
      this.hasError = false
      this.form_data.otp_code = v
      this.disabled_verify = false
    },
    async recallOpt(otp_type = 2) {
      try {
        let obj = {}
        if (otp_type !== 3) {
          obj = {
            otp_type: otp_type,
            phone: this.data_verification.value.phone
          }
        } else {
          obj = {
            otp_type: otp_type,
            email: this.data_verification.value.email
          }
        }
        const { data } = await sendOtpCustomer(obj)
        this.$store.state.loading_axios = false
        if (otp_type === 1) {
          this.$router.push({ name: 'verification_otp', query: { redirect: this.$route.query.redirect }}).catch(() => {})
        }
        this.data_verification.data = data.data
        this.$store.dispatch('data_verification', this.data_verification)
        this.isCall = true
        this.getExpiryTime(data.data.detail.expiry_date)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
